import axios from 'axios';
import { Device } from '../interfaces/api/device';

export interface DeviceFilterParams {
	deviceTypes?: string[];
	controller?: string;
	room?: string;
	floor?: string;
	building?: string;
	organization?: string;
	search?: string;
	ordering?: string;
	fields?: string;
}

function queryBuilderDevice(params: DeviceFilterParams): URLSearchParams {
	const queryParams = new URLSearchParams();
	if (params.deviceTypes && params.deviceTypes.length > 0) {
		for (const deviceType of params.deviceTypes) {
			queryParams.append('device_type', deviceType);
		}
	}
	if (params.controller) {
		queryParams.append('controller', params.controller);
	}
	if (params.room) {
		queryParams.append('room', params.room);
	}
	if (params.floor) {
		queryParams.append('floor', params.floor);
	}
	if (params.building) {
		queryParams.append('building', params.building);
	}
	if (params.organization) {
		queryParams.append('organization', params.organization);
	}
	if (params.search) {
		queryParams.append('search', params.search);
	}
	if (params.ordering) {
		queryParams.append('ordering', params.ordering);
	}
	if (params.fields) {
		queryParams.append('fields', params.fields);
	}
	return queryParams;
}

export async function getDevices(params: DeviceFilterParams = {}): Promise<Device[]> {
	try {
		const queryParams = queryBuilderDevice(params);
		const response = await axios.get<Device[]>('api/devices/', {
			params: queryParams,
		});
		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw error.response;
		}
		throw error;
	}
}

export async function getDevice(id: number, params: DeviceFilterParams = {}): Promise<Device> {
	try {
		const queryParams = queryBuilderDevice(params);
		const response = await axios.get<Device>(`api/devices/${id}/`, {
			params: queryParams,
		});
		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw error.response;
		}
		throw error;
	}
}
